import { getCookie } from './cookies';
import { clearSellerSession } from './sellerSession';

function logoutSeller() {
  clearSellerSession();
  window.location.reload();
}

export async function makeAuthenticatedRequest(
  url: string,
  options: RequestInit = {},
): Promise<Response> {
  const accessToken = getCookie('accessToken');

  if (!accessToken) {
    logoutSeller();
    throw new Error('No access token available');
  }

  const headers = {
    'Content-Type': 'application/json',
    ...options.headers,
    Authorization: `Bearer ${accessToken}`,
  };

  const response = await fetch(url, {
    ...options,
    headers,
  });

  if (response.status === 401 || response.status === 403) {
    logoutSeller();
    throw new Error('Authentication failed');
  }

  return response;
}
